import NonRevenueWaterPage from "./non-revenue-water-page";

export default NonRevenueWaterPage;
